export const getDocPath = (doc) => {
  const hasAbsolutePath = `${doc?.url || ''}`.startsWith('http');

  return `${!hasAbsolutePath ? process.env.NEXT_PUBLIC_CDN_URL : ''}${doc.url}?published-at=${doc.publishedAt}`;
};
